import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const ISMOBILE = window.matchMedia("only screen and (max-width: 768px)").matches

if(document.querySelector('.image-text-gsap1')){
  gsap.registerPlugin(ScrollTrigger);

  gsap.to(".image-text-gsap1", {
    scrollTrigger: {
      trigger: ".section--image-text",
      once: false,
      scrub: true,
      markers: false,
      start: "150 bottom",
      end: "bottom 100",
  },
    x: '-100%'
  });

  gsap.to(".image-text-gsap2", {
    scrollTrigger: {
      trigger: ".section--image-text",
      once: false,
      scrub: true,
      markers: false,
      start: "150 bottom",
      end: "bottom 100",
  },
    x: '100%'
  });
}
